import type { SVGProps } from "react";

export const StatusCircleSevenEighthsIcon = ({
  width = 12,
  height = 12,
  fill = "currentColor",
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" y="0.5" width="11" height="11" rx="5.5" stroke={fill} />
    <path
      d="M3.17157 3.17157C2.5172 3.82594 2.10997 4.68697 2.01926 5.60793C1.92855 6.5289 2.15999 7.45282 2.67412 8.22228C3.18826 8.99174 3.95329 9.55913 4.83886 9.82776C5.72443 10.0964 6.67576 10.0497 7.53073 9.69552C8.38571 9.34138 9.09144 8.70174 9.52768 7.88559C9.96393 7.06944 10.1037 6.12728 9.92314 5.21964C9.7426 4.312 9.25293 3.49504 8.53757 2.90796C7.82221 2.32088 6.92542 2 6 2L6 6L3.17157 3.17157Z"
      fill={fill}
    />
  </svg>
);
